import { useState, useCallback } from 'react';
import { deleteReportAPI } from 'src/components/enterprise/features/Reporting/ManageReportsPage/components/ReportsWrapper/api/deleteReportAPI';
import {
  pushErrorFromAPI,
  pushSuccess,
  SdkErrorResponse,
} from 'src/utilities/notifications';

interface UseDeleteReportProps {
  corpId: string;
  onSuccess: () => void;
}

export interface UseDeleteReportReturn {
  deleteReport: (exportId: string) => Promise<void>;
  isDeleting: boolean;
}

export function useDeleteReport({
  corpId,
  onSuccess,
}: UseDeleteReportProps): UseDeleteReportReturn {
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteReport = useCallback(
    async (exportId: string): Promise<void> => {
      setIsDeleting(true);
      try {
        await deleteReportAPI(corpId, exportId);
        pushSuccess('Report deleted successfully.');
        onSuccess();
      } catch (error) {
        pushErrorFromAPI(error as SdkErrorResponse, {
          fallbackMessage:
            'There was a problem deleting the report. Please try again.',
        });
        throw error;
      } finally {
        setIsDeleting(false);
      }
    },
    [corpId, onSuccess]
  );

  return { deleteReport, isDeleting };
}
